



























































































































































































































import { Component, Emit, Prop } from "vue-property-decorator";
import Vue from "vue";

@Component
export default class ProductOption extends Vue {

    @Prop()
    itemCode!: string;

    @Prop()
    name!: string;

    @Prop()
    cost!: number;

    @Prop()
    image!: string;

    @Prop()
    features!: string[];

    @Prop()
    recommended!: boolean;

    @Prop()
    coupon!: any;

    @Prop()
    activePlan!: boolean;

    mounted() {
        console.log('coupon');
        console.log(this.coupon);
    }

    private get price() {
        if (!this.coupon || !this.coupon.valid) return (this.cost / 100);
        if (this.coupon.percentOff) {
            return (this.cost / 100) * (1.0 - (this.coupon.percentOff / 100.0))
        } else if (this.coupon.amountOff) {
            return (this.cost / 100) - (this.coupon.amountOff / 100.0);
        }
    }

    private get discountText() {
        if (!this.coupon || !this.coupon.valid) return '';

        if (this.coupon.name) {
            return this.coupon.name;
        } else if (this.coupon.percentOff) {
            return this.coupon.percentOff + '% off'
        } else if (this.coupon.amountOff) {
            return 'USD $' + this.coupon.amountOff / 100.0 + ' off'
        }
    }

    @Emit()
    private select() {
        return this.itemCode;
    }

}
